import { FC } from 'react'
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Badge,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SurgeryCard from './SurgeryCard'
import { Surgery } from '../types'

interface DateAccordionProps {
  date: string
  surgeries: Surgery[]
}

const DateAccordion: FC<DateAccordionProps> = ({ date, surgeries }) => {
  // Sort surgeries by room
  const sortedSurgeries = [...surgeries].sort((a, b) => {
    if (a.room < b.room) return -1
    if (a.room > b.room) return 1
    return 0
  })

  // Format the date
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <Accordion defaultExpanded className="surgery-accordion">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className="surgery-date-header"
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            pr: 2,
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
            {formattedDate}
          </Typography>
          <Badge
            badgeContent={sortedSurgeries.length}
            color="secondary"
            sx={{
              '& .MuiBadge-badge': {
                fontWeight: 'bold',
                fontSize: '0.7rem',
              },
            }}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 1 }}>
        <Box className="surgery-summary">
          {sortedSurgeries.map((surgery, index) => (
            <SurgeryCard
              key={`${surgery.patient.id}-${index}`}
              surgery={surgery}
            />
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default DateAccordion
